import ProgressBarWithNumber from './ProgressBarWithNumber';

export default ProgressBarWithNumber;